import { getFullName, useCurrentAccount } from '@gripp/shared-logic';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';
import { Layout } from '../../styles/index';
import { Colors } from '../../themes/colors';
import { CurrentAccountAvatar } from '../currentAccountAvatar';
import { ImagePickerComponent } from '../media/types';
import { EditProfileForm } from './editProfileForm';

export type ProfileFormProps = {
  control: any;
  mediaUrl: string;
  imagePicker: ImagePickerComponent;
  hasBorder?: boolean;
  inputMaxWidth?: number;
  allowsEditingAvatar?: boolean;
  inputBackgroundColor?: string;
  useCropCircle?: boolean;
  /**
   * Replaces the default editable avatar with a custom uploader (e.g. the
   * Crop Circle `AvatarUpload` whose selection is committed on form save).
   * When omitted, the legacy `CurrentAccountAvatar` is used as before.
   */
  avatarSlot?: ReactNode;
};

export const ProfileForm = (props: ProfileFormProps) => {
  const { t } = useTranslation();
  const { account } = useCurrentAccount();

  return (
    <View style={props.hasBorder && styles.border}>
      <View style={styles.row}>
        {props.avatarSlot ?? (
          <CurrentAccountAvatar
            {...props}
            size={props.useCropCircle ? 88 : 80}
            isIconInBox={true}
            editable={true}
            useCropCircle={props.useCropCircle}
          />
        )}
        <Text style={styles.title} variant="titleLarge">
          {getFullName(account?.name)}
        </Text>
      </View>
      <EditProfileForm
        control={props.control}
        inputMaxWidth={props.inputMaxWidth}
        inputBackgroundColor={props.inputBackgroundColor}
        useCropCircle={props.useCropCircle}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  row: {
    ...Layout.row,
    ...Layout.alignCenter,
    ...Layout.justifyStart,
    gap: 8,
  },

  title: {
    fontWeight: '700',
  },
  border: {
    borderBottomWidth: 1,
    borderBottomColor: Colors.grayDivider,
  },
});
